export default "__VITE_ASSET__e63244a5__"